import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import communes from './Communes.json';

import './Adresse.css'
import CodePostalField from '../../custom/CodePostalField';

class Adresse extends Component {

    constructor(props) {
        super(props);
        if(props.adresse != null){
            var codePostal = "";
            if (this.props.adresse.codePostal !== null && this.props.adresse.codePostal !== "") {
                codePostal = Number(this.props.adresse.codePostal);
            }
            this.state = {
                expanded: false,
                communes: this.loadCommunes(codePostal),
                voie1: this.props.adresse.voie1,
                voie2: this.props.adresse.voie2,
                codePostal: codePostal,
                ville: this.props.adresse.ville,
            };
        } else {
            this.state = {
                expanded: false,
                communes: this.loadCommunes(0),
                voie1: "",
                voie2: "",
                codePostal: "",
                ville: "",
            };
        }
    }

    handleChange = () => {
        if (this.state.expanded === false){
            this.setState({ expanded: true });
        } else {
            this.setState({ expanded: false });
        }
    }

    resumeAdresse = () => {
        if(this.props.adresse != null) {
            var ville = this.state.communes.find(commune => commune.codeInsee === this.props.adresse.ville);
            if(ville != null){
                ville = ville.label;
            } else {
                ville = "";
            }

            return this.props.adresse.voie1 + " " + 
                this.props.adresse.voie2 + " " +
                this.props.adresse.codePostal + " " +
                ville;
        }
        return "";
    }

    cpChange = (event) => {
        var cp = "";
        if (event.target.value !== "") {
            cp = Number(event.target.value);
        }
        this.props.adresse.codePostal = cp;
        this.setState({communes : this.loadCommunes(cp), codePostal : cp});    
    }

    handleDataChange = (champ) => (event) => {
        this.props.adresse[champ] = event.target.value;
        this.setState({
            [champ]: event.target.value,
        });
    }

    champsSaisieAdresse = () => {
        const { classes } = this.props;
        return (
            <div className="adresseSaisie">                
                <TextField name="adrVoie1" label="Voie" className="adrVoie" value={this.state.voie1} onChange={this.handleDataChange("voie1")} />
                <TextField name="adrVoie2" label="Voie compl&eacute;ment" className="adrVoie" value={this.state.voie2} onChange={this.handleDataChange("voie2")} />
                <div className="adrInfosVille">
                    <div className="adrCp"><CodePostalField id="adrCp" label="Code postal" value={this.state.codePostal} onChange={this.cpChange} /></div>
                    <TextField
                        name="adrCommune"
                        className="adrCommune"
                        select
                        value={this.state.ville}
                        onChange={this.handleDataChange("ville")}
                        SelectProps={{
                            native: true,
                            MenuProps: {
                            className: classes.menu,
                            },
                        }}
                        margin="normal"
                        >
                        {this.state.communes.map(option => {
                            return (<option key={option.codeInsee} value={option.codeInsee}>
                                {option.label}
                            </option>)
                        })}
                    </TextField>
                </div>
            </div>
        );
    }

    loadCommunes = (codePostal) => {
        var retour = [];
        
        if(codePostal !== 0 && codePostal >= 1000) {
            communes.map(option => {
                if(option.codePostal === codePostal){
                    retour.push(option);
                }
                return option;
            });
            if(retour.length > 0){
                var ville = retour.find(commune => commune.codeInsee === this.props.adresse.ville);
                if(ville == null ){
                    ville = retour[0];
                }
                this.props.adresse.ville = ville.codeInsee;
            }
        }
        return retour;
    }
    
    render(){
        const { classes } = this.props;
        var resume = this.resumeAdresse();
        var champs = this.champsSaisieAdresse();
            return (<div className='adresse'>
                <ExpansionPanel expanded={this.state.expanded} onChange={this.handleChange}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>{this.props.label}</Typography>
                    <Typography className={classes.secondaryHeading}>{resume}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {champs}
                </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>);
    }
}

Adresse.defaultProps = {
    label: "Adresse",
}

Adresse.propTypes = {
    classes: PropTypes.object.isRequired,
    label: PropTypes.string,
    adresse: PropTypes.object,
};

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
});

export default withStyles(styles)(Adresse);


// WEBPACK FOOTER //
// ./src/components/content/client/Adresse.js